import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-700/30 border border-background-700/40 hover:border-primary-500/30 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
      title={`${movie.title} - ${movie.subCategory}电影在线观看`}
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.posterSrc}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} ${movie.subCategory}电影海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-transparent to-transparent opacity-60"></div>

        {movie.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-foreground-50">
            热门
          </span>
        )}
        {movie.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-950">
            新片
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1 text-primary-500 text-xs mb-1">
            <i className="ri-star-fill"></i>
            <span className="font-semibold text-foreground-50">{movie.rating}</span>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-heading font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs px-1.5 py-0.5 rounded bg-background-600/50 text-foreground-400">
            {movie.subCategory}
          </span>
          <span className="text-xs text-foreground-600">{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}